import React from "react";

function SetupPage() {
  return <div>Setup Page</div>;
}

export default SetupPage;
